module.exports = __webpack_public_path__ + "img/symbol_1.e68d53ba.png";